export default __webpack_public_path__ + "5291da6b0e7d2f05e18c13c1e4f04b53.svg";